export enum AdminSignUpSteps {
  SET_PASSWORD = "SET_PASSWORD",
  CONTACT_DETAILS = "CONTACT_DETAILS",
}
